import { render, staticRenderFns } from "./BankAccountBlock.vue?vue&type=template&id=4f0c405e&"
import script from "./BankAccountBlock.vue?vue&type=script&lang=ts&"
export * from "./BankAccountBlock.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports